import { exchangeConstants, alertConstants } from '../_constants'
const initialState = {
  isLoading: false,
  isZeroLoading:false,
  exchangeEntry: '',
  addExchangeMessage: null,
  count: 0,
  exchangeList: [],
  isGetAllError: false,
  deletedData: {},
  masterList: null,
  deleteZeroValueMessage: null,
  zeroValueList: [],
  getZeroValueMessage: '',
  updateExchangeMessage: null
}

export function exchange(state = { ...initialState }, action) {
  state = {
    ...state,
    zeroValueList: [],
    getZeroValueMessage: '',
    exchangeEntry:''

  }
  switch (action.type) {

  case alertConstants.CLEAR:
    return {
      ...state,
      addExchangeMessage: null,
      updateExchangeMessage: null,
      deletedData: {},
      isGetAllError: false,
      exchangeEntry: null,
    }
  case exchangeConstants.GET_ZERO_REQUEST:
    return {
      ...state,
      isZeroLoading: true,
      getZeroValueMessage: null,
      zeroValueList: []
    }
  case exchangeConstants.GET_ZERO_SUCCESS:
    return {
      ...state,
      getZeroValueMessage: action.exchange.message,
      zeroValueList: action.exchange.data,
      isZeroLoading: false,
    }
  case exchangeConstants.GET_ZERO_FAILURE:
    return {
      ...state,
      getZeroValueMessage: action.exchange.message,
      zeroValueList: [],
      isZeroLoading: false,
    }
  case exchangeConstants.DELETE_ZERO_REQUEST:
    return {
      ...state,
      loading: true,
      deleteZeroValueMessage: null
    }
  case exchangeConstants.DELETE_ZERO_SUCCESS:
    return {
      ...state,
      deleteZeroValueMessage: action.exchange.message,
      loading: false,
    }
  case exchangeConstants.DELETE_ZERO_FAILURE:
    return {
      ...state,
      deleteZeroValueMessage: action.exchange.message,
      loading: false,
    }
  case exchangeConstants.ADD_REQUEST:
    return {
      ...state,
      loading: true,
      addExchangeMessage: null
    }
  case exchangeConstants.ADD_SUCCESS:
    return {
      ...state,
      addExchangeMessage: action.exchange.message,
      isLoading: false,
    }

  case exchangeConstants.GETALL_SUCCESS:
    return {
      ...state,
      exchangeList: action.exchange.data,
      count: action.exchange.count,
      isLoading: false,
      addExchangeMessage:null,

    }
  case exchangeConstants.GETALL_FAILURE:
    return {
      error: action.error,
      exchangeList: [],
      isLoading: false,
      count: 0
    }
  case exchangeConstants.GETALL_REQUEST:
    return {
      error: null,
      isLoading: true,
    }
  case exchangeConstants.GETBYID_SUCCESS:
    return {
      ...state,
      exchangeEntry: action.exchange,
      isLoading: false,
      addExchangeMessage: null,
      updateExchangeMessage: null,
    }
  case exchangeConstants.GETBYID_FAILURE:
    return {
      ...state,
      error: action.error,
      isLoading: false,
      addExchangeMessage: null,
      updateExchangeMessage: null,
    }
  case exchangeConstants.GETBYID_REQUEST:
    return {
      ...state,
      exchangeEntry: action.exchange,
      updateExchangeMessage: null,
      isLoading: true,
      addExchangeMessage: null
    }
  case exchangeConstants.GETALL_PAGE_REQUEST:
    return {
      ...state,
      isLoading: true,
      addExchangeMessage: null,
      updateExchangeMessage: null,
    }
  case exchangeConstants.GETALL_PAGE_FAILURE:
    return {
      ...state,
      error: action.error,
      isLoading: false,
      exchangeList: [],
      count: 0,
      isGetAllError: true,
      addExchangeMessage: null,
      updateExchangeMessage: null,
    }
  case exchangeConstants.GETALL_PAGE_SUCCESS:
    return {
      ...state,
      error: action.error,
      isLoading: false,
      addExchangeMessage: null,
      exchangeList: action.exchange.data,
      count: action.exchange.count
    }
  case exchangeConstants.DELETE_REQUEST:
    return {
      ...state,
      isLoading: true,
      addExchangeMessage: null,
      deletedData: {},
      isGetAllError: false,
    }
  case exchangeConstants.DELETE_SUCCESS:
    return {
      ...state,
      isLoading: false,
      deletedData: action.response,
      addExchangeMessage: null
    }
  case exchangeConstants.DELETE_FAILURE:
    return {
      ...state,
      isLoading: false,
      addExchangeMessage: null
    }

  case exchangeConstants.UPDATE_SUCCESS:
    return {
      ...state,
      isLoading: false,
      updateExchangeMessage: action.exchange.message,
      addExchangeMessage: null
    }
  case exchangeConstants.UPDATE_REQUEST:
    return {
      ...state,
      isLoading: true,
      addExchangeMessage: null,
      updateExchangeMessage: null
    }
  case exchangeConstants.UPDATE_FAILURE:
    return {
      ...state,
      isLoading: false,
      updateExchangeMessage: null,
      addExchangeMessage: null,
      error:action.error
    }
  default:
    return state

  }
}
